var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfoval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 179.8",
    style: {
      enableBackground: "new 0 0 1280 179.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Article"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -535.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st0",
    d: "M656,535c252.5,0,477.5,38.5,622.5,98.5l0.8,81.3l-1279.7,0l-0.3-66C141.6,580.1,382.6,535,656,535 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfoval);
export default __webpack_public_path__ + "static/media/halfoval.33f275a2bb72ddf740b49df7a585f19f.svg";
export { ForwardRef as ReactComponent };